<div class="window-pane">
    <ecpl-file-window [businessMode]="businessMode" [config]="uploaderConfig" [uploadedFiles]="uploadedFiles"
      (saveChanges)="checkChange($event)" (activeFolder)="activatedFolder($event)" [(triggerUploader)]="triggerUploader"
      [(ecplApiResponse)]="ecplApiResponse" [folderList]="folderList" (filterFolderEvents)="onFilteredFolder($event)"
      (toogleEditDisplayMode)="toogleEditMode($event)" [adminUsers]="adminUsers"
      (openChecklistOrFormEmit)="openChecklistOrForm($event)"></ecpl-file-window>
</div>